import { StepId } from "./step-config";

export type GroupId = "tutoring-option" | "tutoring-profile" | "complete-setup";

export type GroupDefinition = {
  id: GroupId;
  title: string;
  description?: string;
  steps: StepId[];
};

export const groupsConfig: GroupDefinition[] = [
  {
    id: "tutoring-option",
    title: "Tutoring option",
    description: "Your teaching details",
    steps: ["subjects", "tutoring-options", "qualifications", "contact-info"],
  },
  {
    id: "tutoring-profile",
    title: "Tutoring Profile",
    description: "Your profile page",
    steps: ["tutor-profile"],
  },
  {
    id: "complete-setup",
    title: "Complete set up",
    description: "Subscription & submit",
    steps: ["subscription", "submit"],
  },
];

// Helper to get group for a given step
export function getGroupForStep(stepId: StepId): GroupDefinition | undefined {
  return groupsConfig.find((group) => group.steps.includes(stepId));
}

// Helper to get group index
export function getGroupIndex(stepId: StepId): number {
  return groupsConfig.findIndex((group) => group.steps.includes(stepId));
}

